export default __webpack_public_path__ + "src/assets/c1af5331748fa2ec414c.svg";